module.exports = __webpack_public_path__ + "static/media/screen3.1a2b0717.png";